import { Alignment, Fit, Layout } from "@rive-app/react-canvas";

export const RIVE_COVER_CENTER_LAYOUT = new Layout({ fit: Fit.Cover, alignment: Alignment.Center });
